import React from 'react';
import tw from 'tailwind-styled-components';

function Text4() {
  return (
    <Container>
      <Title>
        {/* TRENDING IN SNEAKERS */}
        TRENDING
      </Title>
      <Underline />
    </Container>
  );
}

const Container = tw.div`px-4 mt-8 mb-4`;
const Title = tw.h3`text-2xl font-semibold text-gray-800 tracking-tight`;
const Underline = tw.div`h-1 w-16 bg-purple-600 rounded mt-2`;

export default Text4;